module.exports = __webpack_public_path__ + "img/79.98a86ac9.png";